import type { ReactNode } from 'react'
import { useTranslation } from 'react-i18next'

import { useSession } from '@/features/auth/useSession'

/**
 * Renders children only for a signed-in user.
 *
 * When the API is unreachable the app stays usable in demo mode rather than
 * bouncing to a login screen that cannot work — Phase 0 runs without a server
 * on a developer's machine.
 */
export function RequireAuth({ children }: { children: ReactNode }) {
  const { t } = useTranslation()
  const session = useSession()

  if (session.isPending) {
    return (
      <div className="grid min-h-dvh place-items-center">
        <p className="text-ink-500 font-mono text-xs">{t('common.loading')}</p>
      </div>
    )
  }

  return <>{children}</>
}
